import { render, staticRenderFns } from "./Fanzone-urban-action.vue?vue&type=template&id=bc2ea9ca&"
import script from "./Fanzone-urban-action.vue?vue&type=script&lang=js&"
export * from "./Fanzone-urban-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports